"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionQSet = void 0;
const getEnabledQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getEnabledQuestions"));
const isInSection_1 = __importDefault(require("@opsbase/lib-form/helpers/isInSection"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const OpPerformQuestion_1 = __importDefault(require("../OpPerformQuestion"));
const makeMyClasses = () => ({
    textBox: {
        lineHeight: '32px',
        backgroundColor: lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        padding: '8px 16px',
        borderRadius: 8,
        width: '100%',
    },
    divBox: {
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        borderRadius: 8,
        padding: 8,
    },
    subTitle: {
        color: lib_palette_1.default.GreyBlue.main,
    },
    title: {},
    inner: {
        width: '100%',
    },
});
function OpPerformQuestionQSet(props) {
    var _a;
    const { highlightSelected } = props;
    const { question } = (0, usePerformQuestion_1.default)();
    const noOfSubQuestions = (_a = question.subQuestions) === null || _a === void 0 ? void 0 : _a.length;
    const { form } = (0, usePerform_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const activeQuestions = (0, getEnabledQuestions_1.default)(question)
        .filter(q => q && !!q.title && q.nodeId !== question.nodeId)
        .filter(q => (0, isInSection_1.default)(form, question, q));
    return (0, react_1.useMemo)(() => {
        if (!noOfSubQuestions)
            return null;
        const details = (react_1.default.createElement(Vertical_1.default, { gutter: true, classes: { root: myCss.inner } }, activeQuestions.map(questionNode => (react_1.default.createElement(OpPerformQuestion_1.default, { questionNode: questionNode, highlightSelected: highlightSelected })))));
        return react_1.default.createElement(react_1.default.Fragment, null, details);
    }, [noOfSubQuestions, highlightSelected, myCss, activeQuestions]);
}
exports.OpPerformQuestionQSet = OpPerformQuestionQSet;
exports.default = OpPerformQuestionQSet;
